import type { InstanceTab } from "../../../lib/instanceDetailTabs";
import { tabIsWindowed, visibleTabs } from "../../../lib/instanceDetailTabs";
import type { InstanceRange } from "../../../lib/instanceDetailRange";
import { RangeControl } from "./RangeControl";
import styles from "./instanceDetail.module.css";

type InstanceTabBarProps = {
  readonly tab: InstanceTab;
  readonly onTabChange: (next: InstanceTab) => void;
  readonly billingEnabled: boolean;
  readonly range: InstanceRange;
  readonly onRangeChange: (next: InstanceRange) => void;
};

export const tabPanelId = (tab: InstanceTab): string => `instance-tab-${tab}`;

// The range sits on the tab bar's right edge and only on tabs whose every
// panel follows it, so it reads as "this view, over this window".
export const InstanceTabBar = ({ tab, onTabChange, billingEnabled, range, onRangeChange }: InstanceTabBarProps): JSX.Element => (
  <div className={styles.tabBar}>
    <div className={styles.tabs} role="tablist" aria-label="Instance sections">
      {visibleTabs(billingEnabled).map((t) => (
        <button
          key={t.value}
          type="button"
          role="tab"
          id={`${tabPanelId(t.value)}-tab`}
          aria-selected={t.value === tab}
          aria-controls={tabPanelId(t.value)}
          className={t.value === tab ? `${styles.tab} ${styles.tabActive}` : styles.tab}
          onClick={() => onTabChange(t.value)}
        >
          {t.label}
        </button>
      ))}
    </div>
    {tabIsWindowed(tab) && (
      <div className={styles.rangeSlot}>
        <span className={styles.rangeLabel}>Last</span>
        <RangeControl value={range} onChange={onRangeChange} />
      </div>
    )}
  </div>
);
